import { action, observable } from 'mobx';
import * as api from '../services/api';
import * as moment from 'moment';

class WarmerStore {
    @observable warmerItems = [];
    @action
    getWarmerLevel = (hubCode) => {
        let dateTimeToPlan = moment().format('YYYY-MM-DD HH:mm:ss');
        api.getWarmerStockLevel(hubCode, dateTimeToPlan)
            .then((res) => {
                this.warmerItems = res.items;
            })
            .catch((error) => console.log(error));
    };
}

const store = new WarmerStore();
export default store;
